import React from 'react'
import { Button, Col, Modal, OverlayTrigger } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'
import ProductMultiplierCalculation from "./ProductMultiplierCalculation"

export default function ProductMultiplierModal(props) {
    const { show, closeModal } = props
    return (
        <Modal show={show} onHide={closeModal} centered size="lg">
            <Modal.Body className="st-modal pad-20">
                <div className="app-modal-content modal_add-customer p-0">
                    <div className="add-customer-form">
                        <div className="d-flex justify-content-between">
                            <div className="app-modal-title-wrapper mb-2 mb-lg-3 p-0">
                                <p className="app-modal-title text-capitalize st-fw-600">Price Calculation/Formula</p>
                            </div>
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={renderTooltipClose}
                            >
                                <Button
                                    className="st-round-btn st-btn-transparent  st-btn-sm p-0 d-flex align-items-center justify-content-center"
                                    onClick={props.closeModal && props.closeModal}
                                >
                                    <FeatherIcon
                                        icon="x"
                                        size="24"
                                        className="icon border st-default-rounded-block" />
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <div className="app-card customer-address-modal" >
                            <div className="app-card-content border st-default-rounded-block pad-25">
                                <Col xs={12} md={12} lg={12} className="px-0">
                                    <ProductMultiplierCalculation {...props} />
                                </Col>
                            </div>
                        </div>
                    </div>
                    {/* {
                        modalLoading && (
                            <div className="app-modal-loading-overlay position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                                <Spinner animation="border" />
                            </div>
                        )
                    } */}
                </div>
            </Modal.Body>
        </Modal>
    )
}
